/*
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-08-30 14:18:02
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-09-24 12:58:25
 * @FilePath: \ces-vue-serve\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Element from 'element-ui';
import { numToFixed } from './libs/util';
import './main.css';

// 打印
import Print from 'vue-print-nb';
// 全局指令
import Directives from './directives/index';
// 用户行为录制（rrweb）
import BehaviorRecorder from './libs/behaviorRecorder';
Vue.prototype.$cloneDeep = (data) => JSON.parse(JSON.stringify(data));

// 全局挂在toFixed
Vue.prototype.$numToFixed = numToFixed;

Vue.config.productionTip = false;
Vue.directive('loadmore', {
  bind (el, binding) {
    const selectWrap = el.querySelector('.el-table__body-wrapper');
    selectWrap.addEventListener('scroll', function () {
      let sign = 0;
      const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight;
      if (scrollDistance <= sign) {
        binding.value();
      }
    });
  }
});
[].includes('');
Vue.use(Print);
Vue.use(Directives);
Vue.use(Element, {
  size: 'mini'
});
// 循环routers
let childrenArr = [];
router.options.routes.forEach((item) => {
  if (item.children) {
    item.children.forEach((items) => {
      if (items.meta.qx && items.meta.qx === 2) { childrenArr.push(items.name); }
    });
  }
});
// 添加到local 里面
localStorage.setItem('childrenItem', JSON.stringify(childrenArr));
window.vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
// 启动用户行为录制（内部延迟等待用户信息就绪，并按服务端配置决定是否录制）
BehaviorRecorder.init();
